export default __webpack_public_path__ + "static/food-cutting-app-store-1-c6656fecbb84297773796c43c1b729c9.svg";